<template>
  <div id="productInformation" style="min-height: calc(100% - 130px);min-width: 900px;position: relative;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ChannelPolicy/pricePublic' }">售价公示</el-breadcrumb-item>
        <el-breadcrumb-item>{{this.$route.query.f}}</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page2">
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -20px;" >
          <el-form-item :label="item.fieldname" label-width="100px" v-if="item.isChecked != 0" v-for="(item,index) in orderProduct2">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="fieldvalue[index]" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="theQuery2(1)" size="small" style="margin-left: 100px;margin-top: 6px;">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>

    <div class="page">
      <el-row style="margin-bottom: 5px;">
        <el-col :span="20" v-if="type.editStatus">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="oneStep(1)" style="margin-right: 10px;" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">新增</el-button>
          <el-button size="small" style="margin-right: 10px;" @click="allDelete(1)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">批量删除</el-button>
          <el-button size="small" style="margin-right: 10px;" @click="batchOutage(1)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">批量导入</el-button>
          <el-button size="small" style="margin-right: 10px;" @click="downTable(1)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">导入模板下载</el-button>
          <el-button size="small" style="margin-right: 10px;" @click="downTable(0)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">下载数据</el-button>
          <el-button size="small" style="margin-right: 10px;" @click="allDelete(2)" v-show="type.logintype == 'KEFU'">批量转移</el-button>
        </el-col>
        <el-col :span="20" v-else>
          <el-button size="small" style="margin-right: 10px;" @click="downTable(0)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">下载数据</el-button>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button @click="allProductHistory" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'" size="small">变更历史</el-button>
        </el-col>
      </el-row>
      <div class="prompt" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{valLength}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="60" fixed v-if="type.logintype != 'DEALER'">
        </el-table-column>
        <el-table-column label="序号" width="80" fixed>
          <template slot-scope="scope">
            {{scope.$index | indexMethod(pageNo,pageSize)}}
          </template>
        </el-table-column>
        <el-table-column :label="item.fieldname" v-for="item in allorder" v-if="item.isChecked == 1">
          <template slot-scope="scope">
            <el-image v-if="item.fieldvalue === 'product_pic'" style="width: 100px; height: 100px;position: relative;" :src="scope.row.product_pic"
            @mouseover="shubiaoClick(scope.row.product_pic,'over')" @mouseout="shubiaoClick(scope.row.product_pic,'out')"></el-image>
            <span v-else>
              {{ scope.row[item.fieldvalue] }}
            </span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" fixed="right" width="150" v-if="type.editStatus">
          <template slot="header" slot-scope="scope">
            操作
            <i class="el-icon-setting" style="color: #409EFF;margin-left: 74px;cursor: pointer;" @click="batchOutage(2)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'"></i>
          </template>
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit-outline" @click="oneStep(2,scope.row.id)" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">编辑</el-button>
            <el-button type="text" icon="el-icon-time" @click="productHistory(scope.row.id,scope.row.brand_name)" v-show="type.logintype != 'HCM' && type.logintype != 'HCMSUB'  && type.logintype != 'KEFU'">变更历史</el-button>
            <span style="color: #d9d9d9;margin-left: 10px;margin-right: 10px;" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">|</span>
            <el-popover
              placement="bottom" style="text-align: center;" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">
              <el-button type="text" icon="el-icon-more" slot="reference">更多</el-button>
              <el-button type="text" icon="el-icon-time" @click="productHistory(scope.row.id,scope.row.brand_name)">变更历史</el-button>
              <br>
              <el-button type="text" icon="el-icon-refresh" @click="transferControl(scope.row.id,scope.row.product_classify_id)">转移售价表</el-button>
              <br>
              <el-button type="text" icon="el-icon-delete" @click="BrandSet(scope.row.id)">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :visible.sync="dialogVisible" width="20%" style="margin-top: 10%;" title="提示" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要删除该公示信息吗？</div>
               <div style="font-size: 14px;">删除后
               <span style="color: #e90e24;font-size: 14px;">相关公示信息将无法找回</span>
            </div>
           </div>
        </div>
        <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteSuc" size="small" :loading="delLoading">确 定</el-button>
        <el-button @click="dialogVisible = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 批量删除 -->
      <el-dialog :visible.sync="openPhoneShow" width="360px" style="margin-top: 10%;" title="提示" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要删除勾选的{{valLength}}项公示信息吗？</div>
               <div style="font-size: 14px;">删除后
               <span style="color: #e90e24;font-size: 14px;">相关公示信息将无法找回</span>
            </div>
           </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="openPhone()" size="small" :loading="allDelLoading">确 定</el-button>
          <el-button @click="openPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 批量删除 -->

      <el-dialog title="批量导入"
      class="importModal"
        :visible.sync="BulkImportShow"
        :close-on-click-modal="false"
        width="640px"
        style="margin-top: 10%;" id="dialog">
        <div class="wrap" style="margin: 10px;">
          <el-upload
            ref="newupload"
            class="upload-demo"
            drag
            action="hcm/hcmProduct/readExcelFile"
            :auto-upload="false"
            :data="ruleForm"
            multiple
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
            :on-success="confirmUpload"
            >
            <i class="el-icon-upload" style="color: #BDA571;"></i>
            <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
              <br>
              <span style="font-size: 14px;color: #d4d4d4;">
                支持扩展名：.xls .xlsx
              </span>
            </div>
          </el-upload>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
          <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 编辑组件 -->
      <TheEditor ref="TheEditorChild" @theQueryParams="fn" style="overflow-y: auto;"></TheEditor>
      <!-- 新增组件 -->
      <newAdd ref="newAddChild" @theQueryParams="fn" style="overflow-y: auto;"></newAdd>
      <!-- 自定义字段组件 -->
      <customField ref="customFieldChild" @customShow="customShow"></customField>
      <!-- 转移产品至售价表 -->
      <productPricing ref="productPricingChild" @customShow="customShow"></productPricing>
      <!-- 导入报错 -->
      <importErrorResult :modalInfo="modalInfoErrs" :tableData="tableDataErr" :columsData="columsDataErr"/>
      <div v-if="picShow" style="position: fixed;top: 20%;left: 40%;">
        <img :src="iamge" style="height: 600px;"></img>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  import axios from "axios";
  import TheEditor from './TheEditor';
  import newAdd from './newAdd';
  import customField from './customField';
  import productPricing from './productPricing';
  import importErrorResult from "components/importErrorResult";

  export default {
    data() {
      return {
        picShow: false,
        bulLoading: false,
        delLoading: false,
        allDelLoading: false,
        columsDataErr:[],
        tableDataErr:[],//错误信息弹框
        modalInfoErrs:{
          isShow:false
        },//错误信息弹框
        checkAll: 1,
        newId: '',
        hcmProductIds2: '',
        tableData: [],
        allorder: [],
        fieldvalue: [],
        orderProduct: [],
        orderProduct2: [],
        orderPrice: [],
        keyArray: [],
        orderMemo: [],
        multipleSelection: [],
        submitArray: {},
        dialogVisible: false,
        openPhoneShow: false,
        BulkImportShow: false,
        valLength: 0,
        totalNum: 100,
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        ruleForm: {
         classifyid: this.$route.query.e,
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        type:'',
        iamge: '',
      }
    },
    mounted() {
      this.theQuery();
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
    },
    methods: {
      shubiaoClick(product_pic,type) {
        if (type == 'over') {
          this.iamge = product_pic
          this.picShow = true
        } else {
          this.picShow = false
        }
      },
      // 转移售价表
      transferControl(id,classifyId) {
        this.$refs.productPricingChild.transferChildShow(id,classifyId,1)
      },
      fn(param) {
        this.theQuery()
      },
      customShow() {
        this.theQuery();
      },
      confirmUpload(response) {
        console.log(1111111111)
        console.log(response)
        if (response.status == 10000) {
          this.$refs.newupload.clearFiles();
          // 批量导入错误提示数据处理
          if (response.data.length > 0) {

            if (this.allorder.length > 0) {
              this.columsDataErr = []
              for (let i in this.allorder) {
                if (this.allorder[i].isChecked === 1) {
                  this.columsDataErr.push({
                    fieldClassify: this.allorder[i].fieldClassify,
                    fieldRequired: this.allorder[i].fieldRequired,
                    id: this.allorder[i].id,
                    isChecked: this.allorder[i].isChecked,
                    label: this.allorder[i].fieldname,
                    prop: this.allorder[i].fieldvalue,
                    width: this.allorder[i].fieldClassify == 'PRODUCT'?'321':'320',
                  })
                }
              }
            }

            this.tableDataErr = response.data
            this.modalInfoErrs = {
              isShow:true,
              reminder:response.message
            }
          } else {
            this.$message({
              message: response.message,
              type: 'success'
            });
          }
          this.bulLoading = false
          this.theQuery();
          this.BulkImportShow = false

        } else {
          this.bulLoading = false
          this.theQuery();
          this.BulkImportShow = false
          this.$message.error(response.message);
          this.$refs.newupload.clearFiles();
        }
      },
      beforeUpload(file) {
        let Xls = file.name
        if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
          return file
        }else {
          this.$message.error('上传文件只能是 xls/xlsx 格式!')
          return false
        }
      },
      BulkImportShowf() {
        this.BulkImportShow = false
        this.$refs.newupload.clearFiles();
      },
      BulkImport() {
        this.bulLoading = true
        this.$refs.newupload.submit();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        if (this.checkAll == 2) {
          this.valLength = this.totalNum;
        } else {
          this.valLength = this.multipleSelection.length;
        }
      },
      allDelete(e) {
        if (this.multipleSelection.length != 0) {
          if (e == 1) {
            this.openPhoneShow = true;
          } else {
            var arr = [];
            this.multipleSelection.forEach((val,index,val_arr)=>{
              arr.push(val.id)
            });
            this.hcmProductIds2 = arr.join();
            let params={
              classifyId: this.$route.query.e,
            }
            if (this.submitArray) {
              params.term = JSON.stringify(this.submitArray)
            }
            if (this.checkAll == 2) {
              params.hcmProductIds = 'checkAll'
            } else {
              params.hcmProductIds = this.hcmProductIds2
            }
            console.log(params)
            this.$refs.productPricingChild.transferChildShow(params.hcmProductIds,params.classifyId,2,params.term)
          }

        } else {
          this.$message({
            message: '请选择用户',
            type: 'warning'
          });
        }
      },
      downTable(e){
        var dataName
        for (var i = 0; i < this.keyArray.length; i++) {
          this.submitArray[this.keyArray[i]] = this.fieldvalue[i]
         }
        let datas={
          classifyid: this.$route.query.e,
          term: JSON.stringify(this.submitArray)
        }
        if (e == 0) {
          datas.istemplet = 0
          dataName = '售价公示数据.xlsx'
        } else {
          datas.istemplet = 1
          dataName = '售价公示导入模板.xlsx'
        }
        fetch({
            url: "hcm/hcmProduct/exportExcel",
            method: "get",
            params:datas,
            noFormat: true,
            responseType: "blob"
        })
        .then((res)=>{
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', dataName)
          document.body.appendChild(link)
          link.click()
        })
      },
      openPhone() {
        this.allDelLoading = true
        var arr = [];
        this.multipleSelection.forEach((val,index,val_arr)=>{
          arr.push(val.id)
        });
        this.hcmProductIds2 = arr.join();
        let params={
          classifyId: this.$route.query.e,
        }
        if (this.submitArray) {
          params.term = JSON.stringify(this.submitArray)
        }
        if (this.checkAll == 2) {
          params.hcmProductIds = 'checkAll'
        } else {
          params.hcmProductIds = this.hcmProductIds2
        }
        fetch({
          url: "hcm/hcmProduct/delete",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.allDelLoading = false
            this.theQuery();
            this.openPhoneShow = false
            this.valLength = 0
          } else {
            this.allDelLoading = false
            this.theQuery();
            this.openPhoneShow = false
          }
        })
      },
      batchOutage(e) {
        if (e == 1) {
          this.BulkImportShow = true
        }else{
          this.$refs.customFieldChild.childShow(this.$route.query.e)
        }
      },
      // 删除
      deleteSuc() {
        this.delLoading = true
        let params={
          hcmProductIds: this.newId,
          classifyId: this.$route.query.e
        }
        fetch({
          url: "hcm/hcmProduct/delete",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.delLoading = false
            this.theQuery();
            this.dialogVisible = false
          } else {
            this.delLoading = false
            this.theQuery();
            this.dialogVisible = false
          }
        })
      },
      theQuery(e) {
        this.submitArray = {};
        for (var i = 0; i < this.keyArray.length; i++) {
          this.submitArray[this.keyArray[i]] = this.fieldvalue[i]
         }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          classifyid: this.$route.query.e,
          term: JSON.stringify(this.submitArray)
        }
        fetch({
          url: "hcm/hcmProduct/getPageBybmcid",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.content;
            this.totalNum = data.totalElements;
            this.keyArray = [];
            if (data.obj == 0) {
              if (this.type.logintype == 'HCM' || this.type.logintype == 'KEFU' || this.type.logintype == 'HCMSUB') {
                this.$refs.customFieldChild.childShow(this.$route.query.e)
              }
            }
            this.getOrder();
          }
        })
        .catch(err => {

        })
      },
      theQuery2(f) {
        console.log(this.fieldvalue)
        console.log(this.keyArray)
        console.log(this.submitArray)
        this.submitArray = {};
        for (var i = 0; i < this.keyArray.length; i++) {
          this.submitArray[this.keyArray[i]] = this.fieldvalue[i]
         }
        if (f == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          classifyid: this.$route.query.e,
          term: JSON.stringify(this.submitArray)
        }
        fetch({
          url: "hcm/hcmProduct/getPageBybmcid",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1
            this.tableData = data.content;
            this.totalNum = data.totalElements;
            // this.keyArray = [];
            this.getOrder();
          } else if (res.status == '10400') {
          }
        })
        .catch(err => {

        })
      },
      getOrder(e) {
        let params={
          productClassifyid: this.$route.query.e
        }
        fetch({
          url: "hcm/hcmCustomModel/getByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.orderMemo = data.memo.data;
            this.orderPrice = data.price.data;
            this.orderProduct = data.product.data;
            this.orderProduct2 = [];
            if (e != 1) {
              for (var i = 0; i < data.product.data.length; i++) {
                if (data.product.data[i].isChecked == 1) {
                  this.orderProduct2.push({
                    fieldvalue: data.product.data[i].fieldvalue,
                    fieldname: data.product.data[i].fieldname,
                  });
                }
              }
            }
            var newarry = [];
            var newarry2 = [];
            var arrv = [];
            newarry = this.orderPrice.concat(this.orderProduct);
            newarry2 = this.orderMemo.concat(newarry);
            this.compare();
            newarry2.sort(this.compare('sort'));
            if (e != 1) {
              this.allorder = newarry2;
            }
            console.log(this.allorder)
            this.tableData.forEach((v,i)=>{
              Object.keys(v).forEach(v=>{
                  arrv.push(v)
              })
            })
            this.keyArray = [];
            for (var i = 0; i < this.orderProduct.length; i++) {
              this.keyArray.push(this.orderProduct[i].fieldvalue)
            }
          }
        })
      },
      //数组排序
      compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        }
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.valLength = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.valLength = 0
        }
      },
      // 新增编辑组件
      oneStep(e,f) {
        if (e == 1) {
          this.$refs.newAddChild.getOrder(this.$route.query.e,this.$route.query.f)
          this.$refs.newAddChild.newAddChildShow()
        } else {
          this.$refs.TheEditorChild.editorGetOrder(this.$route.query.e,f)
          this.$refs.TheEditorChild.editorGetOrderShow()
        }
      },
      BrandSet(e) {
        this.newId = e;
        this.dialogVisible = true;
      },
      productHistory(f,e) {
        this.$router.push({
        path: '/productHistory',query: { id: f,name:e,newid: this.$route.query.e,newname:this.$route.query.f }
        })
      },
      allProductHistory() {
        this.$router.push({
        path: '/allProductHistory',query: { id: this.$route.query.e,name:this.$route.query.f }
        })
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery();
      },
    },
    components: {
      pagination,TheEditor,newAdd,customField,productPricing,importErrorResult
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }

  .page {
    padding: 20px;
    margin: 10px 20px 20px 20px;
    background-color: white;
    min-height: 600px;
  }
  .page2 {
    padding: 20px 20px 0px 20px;
    min-width: 900px;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .setting {
    margin-right: 10px;
    font-size: 18px;
    width: 35px;
    height: 35px;
    background-color: #e7f3fd;
    color: #108cee;
    display: inline-block;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
  }
  .headerSize {
    line-height: 40px;
    text-align: center;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin: 8px 0 8px 0;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }


</style>
<style lang="scss">
#productInformation {
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .w-e-menu{
    z-index: 2 !important;
  }
  #setHeader {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #f6f7fb;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
